import { type SpaceStep } from '@vello/tokens';

/**
 * Shared helpers of the D548 component library (`library.css`). Internal: nothing here is re-exported by the package index
 * except the `GapStep` type.
 */

/**
 * A space-token step (`--space-N`) a layout component spaces its children with: 1 (4px) … 24 (96px). Components take the
 * STEP, never a length — there is no way to pass a px value, which is the point of the vocabulary.
 */
export type GapStep = SpaceStep;

/** Join class names, dropping the empty ones. */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter((p): p is string => typeof p === 'string' && p !== '').join(' ');
}

/** The `data-gap` attribute value for a step (the stylesheet maps it to `--space-N`). */
export function gapAttr(gap: GapStep | undefined): string | undefined {
  return gap === undefined ? undefined : String(gap);
}
